import React from "react";
import { Box, Button } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import CircularProgress from "@mui/material/CircularProgress";
import DialogTitle from "@mui/material/DialogTitle";
import ErrorIcon from "@mui/icons-material/Error";

type Icon = "danger" | "warning" | "info";

interface Props {
  isOpen: boolean;
  title?: string;
  icon?: Icon;
  contentText: string;
  onCancel: () => unknown;
  onConfirm?: () => unknown;
  confirmLabel?: string;
  cancelLabel?: string;
  isLoading?: boolean;
}

export default function ConfirmModal({
  isOpen,
  title,
  icon,
  contentText,
  onCancel,
  onConfirm,
  confirmLabel,
  cancelLabel,
  isLoading,
}: Props): JSX.Element {
  return (
    <Dialog
      open={isOpen}
      onClose={(event, reason) => {
        onCancel();
      }}
      scroll="paper"
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      maxWidth="lg"
    >
      <DialogTitle id="scroll-dialog-title">
        <Box display="flex" justifyContent="flex-end">
          <Box flexGrow={1} display="flex" alignItems="center">
            {icon === "danger" && (
              <Box display="flex" mr={1}>
                {" "}
                <ErrorIcon color="error" />
              </Box>
            )}
            {title}
          </Box>
          <Box onClick={onCancel} className="pointer"></Box>
        </Box>
      </DialogTitle>
      <DialogContent dividers={true}>
        <Box display="flex">
          <span>{contentText}</span>
        </Box>
      </DialogContent>
      <DialogActions>
        <Box
          display="flex"
          justifyContent="end"
          alignItems="center"
          flexBasis="100%"
        >
          <Box mr={2}>
            {isLoading ? (
              <CircularProgress></CircularProgress>
            ) : (
              <>
                {onConfirm && (
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    onClick={onConfirm}
                  >
                    {confirmLabel || "OK"}
                  </Button>
                )}
              </>
            )}
          </Box>
          <Button
            variant="outlined"
            color="primary"
            size="large"
            onClick={onCancel}
          >
            {cancelLabel || "Cancel"}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
}
